import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="pt-32 pb-24 bg-[#faf6ef] min-h-screen">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-[#b4462a] text-xs tracking-[0.3em] uppercase font-bold mb-4">Legal</div>
        <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] tracking-tight font-light mb-8 text-[#1e2a5a]">Privacy Policy</h1>
        <div className="rounded-3xl bg-white shadow-soft p-8 md:p-12 space-y-6 text-[#1a1a1a]/80 leading-[1.8]">
          <p className="text-sm text-[#1a1a1a]/55 italic">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">1. What We Collect</h2>
            <p>When you submit a quote request or newsletter form, we collect: name, company, email, phone (optional), country, and your stated requirements. We also collect standard web analytics data (page visits, referrers, device type) to improve the site. This is placeholder content — replace with your final legal copy before go-live.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">2. How We Use It</h2>
            <p>Your inquiry is shared only with our internal export desk to build a personalised quote. We do not sell, rent, or share your contact information with third parties for marketing purposes.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">3. Where We Store It</h2>
            <p>Inquiries are stored in our secured database and mirrored to an internal Google Sheet accessible only to our sales and operations team.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">4. Cookies &amp; Analytics</h2>
            <p>We use minimal cookies for analytics (Google Analytics 4) and for basic session functionality. You can disable cookies in your browser settings.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">5. Your Rights</h2>
            <p>You may request access to, correction of, or deletion of your personal data at any time. Write to <a href="mailto:export@indusart.in" className="text-[#b4462a] underline">export@indusart.in</a>.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">6. Data Retention</h2>
            <p>We retain inquiry data for up to 5 years for business correspondence, after which it is archived or deleted.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">7. Contact</h2>
            <p>Questions about this Privacy Policy? <Link to="/contact" className="text-[#b4462a] underline">Contact us</Link>.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
